














import { Prop, Component, Vue } from 'vue-property-decorator';

@Component({})
export default class QRatingFace extends Vue {
  @Prop({ default: 5 }) readonly rating!: number | string;
  @Prop({ default: false }) readonly selected!: boolean;

  iconHexTable = {
    1: {
      icon: 'mdi-emoticon-frown-outline',
      color: 'red',
      text_code: 'model.feedback.rating_1',
    },
    2: {
      icon: 'mdi-emoticon-confused-outline',
      color: 'orange darken-1',
      text_code: 'model.feedback.rating_2',
    },
    3: {
      icon: 'mdi-emoticon-neutral-outline',
      color: 'amber',
      text_code: 'model.feedback.rating_3',
    },
    4: {
      icon: 'mdi-emoticon-happy-outline',
      color: 'light-green accent-4',
      text_code: 'model.feedback.rating_4',
    },
    5: {
      icon: 'mdi-emoticon-excited-outline',
      color: 'green accent-4',
      text_code: 'model.feedback.rating_5',
    },
  };

  isHovered = false;

  get icon() {
    return this.iconHexTable[this.rating].icon;
  }

  get iconColor() {
    return this.selected || this.isHovered
      ? this.iconHexTable[this.rating].color
      : null;
  }

  get iconTextCode() {
    return this.iconHexTable[this.rating].text_code;
  }
}
